import request from '@/utils/request';

// 获取用户个人信息
export function getUserProfile() {
  return request({
    url: '/profile/me',
    method: 'get'
  });
}

// 更新用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/profile/me',
    method: 'put',
    data
  });
}